import AuthenticationContext from 'adal-angular';

export default function createAdalAuthenticationContext(
    authUrl: string,
    clientId: string,
    redirectUri: string
): AuthenticationContext {
    const config = {
        instance: authUrl,
        clientId: clientId,
        redirectUri: redirectUri,
        popUp: true,
        navigateToLoginRequestUrl: false,
    };

    return new AuthenticationContext(config);
}
